import React from 'react';

const ChargeForSuspensionChx = (props) => {
  const { classes, register, disabled = false } = props;

  return (
    <div className={classes.FormItem}>
      <input
        type="checkbox"
        className={classes.Checkbox}
        id="charge-for-suspension-checkbox"
        name="chargeForSuspension"
        ref={register}
        disabled={disabled}
      />
      <label className={classes.Label} htmlFor="charge-for-suspension-checkbox">
        Charge for Suspension
      </label>
    </div>
  );
};

export default ChargeForSuspensionChx;
